// 合同抽取列表页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="合同关键词抽取"></route-name>
    <!-- content 内容 -->
    <div class="content">
      <!-- 搜索栏 -->
      <div class="search">
        <div>
          <el-button
            type="primary"
            size="small"
            plain
            @click="$router.push('/smartDoc/docExtract/extract')"
            ><i class="el-icon-upload"></i>&nbsp;&nbsp;&nbsp;上传文件</el-button
          >
          <el-button size="small" @click="delDoc"
            ><i class="el-icon-delete"></i>&nbsp;&nbsp;&nbsp;删除文件</el-button
          >
        </div>
        <div>
          <el-input
            placeholder="请输入文件名"
            v-model="fileName"
            size="small"
            clearable
            style="margin-right: 10px"
          >
          </el-input>
          <el-button size="small" @click="searchData(1)">查询</el-button>
          <el-button size="small" @click="rest">重置</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        style="min-height: 64vh"
        :data="extrData"
        border
        v-loading="TableLoading"
        @selection-change="
          (rows) => {
            this.selected = rows;
          }
        "
      >
        <el-table-column type="selection" width="45" />
        <el-table-column
          prop="docIndex"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column prop="contractName" label="合同名称"></el-table-column>
        <el-table-column
          prop="extractTime"
          label="合同上传时间"
        ></el-table-column>
        <el-table-column
          prop="uploadTime"
          label="关键信息提取时间"
        ></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span
              :style="{ color: smartStatus[scope.row.extractStatus].color }"
              >{{ smartStatus[scope.row.extractStatus].status }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              class="action pointer"
              :class="{
                'not-allowed': scope.row.extractStatus !== 1 ? true : false,
              }"
              :style="{ color: scope.row.extractStatus !== 1 ? '#aaaaaa' : '' }"
              @click="resultInfo(scope.row)"
              >查看结果</span
            >
            <span
              class="action pointer"
              v-if="scope.row.extractStatus == 1"
              @click="resultDown(scope.row)"
              >下载报告</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row>
        <div class="page-sty page-flex-end">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageModel.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageModel.pageSize"
            layout="sizes, prev, pager, next, total"
            :total="pageModel.total"
          />
          <el-go
            :page-size="pageModel.pageSize"
            :total="pageModel.total"
            @current-change="handleCurrentChange"
          ></el-go>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
// 组件
import ElGo from "@/components/go/Go.vue";
import RouteName from "@/components/route-name";
// 接口
import { ApiMethods } from "../../../assets/js/http-serve/http-methods";

export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      fileName: "",
      extrData: [],
      TableLoading: false,
      selected: [],
      pageModel: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      smartStatus: {
        // <!-- 0：进行中，1:成功，2失败 -->
        0: { status: "抽取中", color: "#fcb270" },
        1: { status: "抽取成功", color: "#67c23a" },
        2: { status: "抽取失败", color: "#f56c6c" }
      }
    };
  },
  // data end
  methods: {
    // 重置
    rest () {
      this.fileName = "";
      this.searchData(1);
    },
    // 搜索
    searchData (pageNo) {
      this.TableLoading = true;
      const { page, pageSize } = this.pageModel;
      const params = {
        fileName: this.fileName,
        page,
        pageSize
      };
      if (pageNo) params.page = 1;
      this.smartAPI.extractList(params).then(res => {
        if (res.success) {
          const { data } = res;
          data.data.forEach((elem, i) => {
            elem.docIndex = (data.pageNum - 1) * data.pageSize + i + 1;
          });
          this.extrData = data.data;
          this.pageModel.total = data.total;
        } else {
          this.$message.error(res.description);
        }
        this.TableLoading = false;
      });
    },
    // 删除文件
    delDoc () {
      if (this.selected.length === 0)
        return this.$message.error("请选择要操作的数据");
      // 需要取出selected数组中的id
      let extractIds = [];
      this.selected.forEach(item => {
        extractIds.push(item.extractId);
      });
      this.smartAPI
        .extractDel({ extractIds: extractIds.toString() })
        .then(res => {
          if (res.success) {
            this.$message.success(res.description);
            this.selected = [];
            this.searchData();
          } else {
            this.$message.error(res.description);
          }
        });
    },
    // 查看结果
    resultInfo (row) {
      if (row.extractStatus !== 1) return;
      this.$router.push({
        path: "/iframeView/examineInfo",
        query: { url: row.resUrl }
      });
    },
    async resultDown (row) {
      this.smartAPI
        .extractDown({ extractId: row.extractId })
        .then(async res => {
          if (res.success) {
            const { targetId } = res.data;
            const fix = targetId.substring(
              targetId.lastIndexOf(".") + 1,
              targetId.length
            );
            let downRes = await ApiMethods.FileOperController.download_get({
              fix,
              ...res.data
            });
            if (downRes.success && downRes.url) {
              window.location.href = downRes.url;
            } else {
              this.$message.error(downRes.err);
            }
          } else {
            this.$message.error(res.description);
          }
        });
    },
    // 每页条数改变
    handleSizeChange (val) {
      this.pageModel.page = 1;
      this.pageModel.pageSize = val;
      this.searchData();
    },
    // 页数改变
    handleCurrentChange (val) {
      this.pageModel.page = val;
      this.searchData();
    }
  },
  // methods end
  components: { RouteName, ElGo },
  created () {
    this.searchData();
  }
};
</script>

<style scoped lang="less">
.page-sty {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    /*height: calc(85vh - 36px);*/
    padding: 16px;
    overflow: auto;
    .search {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      > div {
        width: 300px;
        display: flex;
        align-items: center;
      }
    }
  }
  .action {
    display: inline-block;
    cursor: pointer;
    margin: 0 5px;
    color: #290202;
  }
  .not-allowed {
    cursor: not-allowed !important;
  }
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docExtract/extractList.vue